var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "pe"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_cl.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_br.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "cl"
      ? _c("div", { attrs: { id: "consignments-content" } }, [
          _c(
            "div",
            {
              staticClass: "card-item mt-6 date-filter",
              attrs: { id: "investors-consignments-card" },
            },
            [
              _vm.isLoadInvestors
                ? _c("InvestorConsignmentsFilters", {
                    attrs: {
                      investors: _vm.investors,
                      "message-result": _vm.messageResult(),
                      "enable-excel-button":
                        _vm.filteredConsignments.length > 0,
                    },
                    on: {
                      filter: _vm.filterConsignments,
                      excelButtonClicked: _vm.downloadExcel,
                    },
                    model: {
                      value: _vm.filtersModal,
                      callback: function ($$v) {
                        _vm.filtersModal = $$v
                      },
                      expression: "filtersModal",
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "spinner-content",
                  class: _vm.isLoading ? "is-loading" : "is-hidden",
                },
                [_vm._m(0)]
              ),
              !_vm.filteredConsignments.length
                ? _c("div", { staticClass: "message-info has-text-centered" }, [
                    _c("i", {
                      staticClass: "fas fa-exclamation-circle is-pulled-left",
                    }),
                    _vm._m(1),
                  ])
                : _vm._e(),
              _c(
                "transition-group",
                {
                  staticClass: "consignments-group",
                  attrs: {
                    name: "consignments-transition",
                    appear: "",
                    tag: "div",
                  },
                },
                _vm._l(_vm.filteredConsignments, function (consignment, i) {
                  return _c("investor-consignment", {
                    key: consignment._id,
                    style: { "--i": i },
                    attrs: {
                      investor: _vm.investors.find(
                        (investor) => investor._id === consignment.investorId
                      ),
                      "consignment-data": consignment,
                      "consignment-index": i,
                      "current-extended-consignment":
                        _vm.currentExtendedConsignment,
                      "show-investors": _vm.investors.length > 1,
                      headers: _vm.excelHeaders,
                    },
                    on: {
                      setCurrentExtendedConsignment: (index) => {
                        _vm.currentExtendedConsignment = index
                      },
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "spinner" }, [
      _c("div", { staticClass: "double-bounce1" }),
      _c("div", { staticClass: "double-bounce2" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "message-text" }, [
      _c("span", [
        _vm._v(
          " No hay remesas que cumplan con los valores introducidos en el filtro, vuelve a filtrar para obtener resultados. "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }